export const navLinks = [
  { id: 'collections', label: 'Collections' },
  { id: 'house', label: 'The House' },
  { id: 'showroom', label: 'Showroom' },
  { id: 'reels', label: 'Reels' },
  { id: 'visit', label: 'Visit' },
];

export default navLinks;
